import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';

import locale from '../locale.json';
import FileUploader from './FileUploader.js';
import SendButton from './SendButton.js';

const styles = theme => ({
  container: {
    flexWrap: "wrap",
    width: "100%",
  },
  textField: {
    width: "100% ",
    padding: "0 ",
    flex: "1 ",
    "& fieldset": {
      border: "0 "
    },
    boxShadow: "none ",
    "&:focus": {
      border: "none ",
      background: "none "
    }
  },
  button: {
    margin: theme.spacing(1),
    display: "flex",
    justifyContent: "flex-start",
    textTransform: "none",
    textAlign: "left",
    width: "100%",
    color: "black",
    padding: 0,
    "& span": {},
    "&:hover": {
      backgroundColor: "rgb(244, 251, 255)"
    }
  },
  sendButton: {
    display: "flex",
    justifyContent: "center",
    margin: "auto",
    color: "white",
    backgroundColor: theme.palette.primary.light,
    transition: "background-color 0.1s",
    "&:disabled": { backgroundColor: theme.palette.primary.dark, color: "white" },
    "&:hover": {
      backgroundColor: "rgb(164, 174, 232)"
    }
  },
  paper: {
    flex: 1,
    zIndex: 100000,
    maxHeight: "150px",
    overflowY: "auto",
    width: '75%',
    borderRadius: "0",
    backgroundColor: theme.palette.primary.main
  },
  // input: {
  //   padding: 0
  //   border: "none"
  //   borderRadius: "2em",
  //   margin: "auto",
  //   boxShadow:
  //     "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
  //   width: "100%",
  //   fontSize: "14px",
  //   transition: "background-color 0.3s",
  //   "&:focused": {
  //     border: "none"
  //   },
  //   "& fieldset": { border: 0 }
  // },
  normalInput: {
    marginTop: "1% ",
    display: "flex ",
  },
  input: {
    fontFamily: "'Lato',sans-serif",
    fontSize: "1.4rem ",
    color: "white",
    boxShadow: "none ",
    "&:focus": {
      border: "none ",
      background: "none "
    },
    '&::placeholder': {
      fontStyle: 'italic',
      opacity: "100%"
    },
  },
  chipContainer: {
    margin: "0.5em 0 0 1em"
  },
  chip: {
  }
});

class MyTextInput extends React.Component {
  state = {
    height: 0,
    disabled: true,
    files: []
  };

  handleForm(event) {
    event.preventDefault();
    this.setState({ disabled: true, files: [] });
    if (this.props.text.trim()) {
      this.props.onSend(this.props.text.trim());
    }

  }

  _handleKeyPress = e => {
    if (e.key === "Enter" && this.props.text.trimLeft() !== "") {
      this.handleForm(e);
    }
  };


  handleChange = event => {

    let value = event.target.value;
    if (value.trimLeft()) {
      this.setState({ disabled: false });
    } else {
      this.setState({ disabled: true });
    }
    this.props.onChange(value);
  };

  disableButton = (text) => {
    return text.length > 0 ? false : true
  }


  componentDidUpdate() {
    let h = this.textInput.clientHeight;
    if (h !== this.state.height) {
      this.props.scroll();
      this.setState({ height: h });
    }
  }



  setFile = (files) => {
    this.setState({ files: files })
  }

  renderAdornment() {

    if (this.props.uploader) {
      return (
        <FileUploader files={this.state.files} setFile={this.setFile} />
      )
    }
    else {
      return null;
    }
  }

  handleDelete = name => e => {
    const filtered = this.state.files.filter(file => file.name !== name)
    this.setState({ files: filtered })
  }

  renderChips() {
    const { classes } = this.props;
    return (
      <div className={classes.chipContainer}>
        {this.state.files.map(file => {
          return (
            <Chip
              key={file.name}
              label={file.name}
              onDelete={this.handleDelete(file.name)}
              className={classes.chip}
              color="primary"
              variant="outlined"
            />
          )
        })}
      </div>
    )
  }

  getTextArea() {
    if (this.props.selected_language) {
      return locale[this.props.selected_language].textArea
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <form
        className={classes.container}
        noValidate
        autoComplete="off"
        onSubmit={this.handleForm.bind(this)}
        value={this.state.value}
        title="formulario enviar mensaje"
        aria-label="formulario enviar mensaje"
      >
        {this.state.files.length > 0 && this.renderChips()}

        <div
          title="formulario enviar mensaje"
          aria-label="formulario enviar mensaje"
          ref={textInput => (this.textInput = textInput)}
          className={classes.normalInput}
        >
          <Paper className={classes.paper} title="campo de texto" aria-label="campo de texto">
            <TextField
              title="campo de texto"
              aria-label="campo de texto"
              style={{ heigth: "100px" }}
              autoFocus
              className={classes.textField}
              disabled={false}
              id="campo-enviar"
              margin="dense"
              maxRows={5}
              multiline
              onChange={this.handleChange}
              onKeyPress={this._handleKeyPress}
              placeholder={this.getTextArea()}
              role="textbox"
              value={this.props.text}
              variant="outlined"
              InputProps={{
                title: "campo de texto",
                'aria-label': "campo de texto",
                className: classes.input,
                classes: { input: classes.input },
                endAdornment: this.renderAdornment(),
              }}
              inputProps={{
                title: "campo de texto",
                'aria-label': "campo de texto",
                maxLength: 200
              }}
            />
          </Paper>
          <div style={{ display: "flex" }}>
            <SendButton title="Enviar mensaje" />
          </div>
        </div>
      </form>
    );
  }
}

MyTextInput.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MyTextInput);
